import React, { type ReactElement } from 'react';

import Clickable, { type ClickableProps } from '#@/components/Clickable';
import type { ToastObject } from '#@/components/Toast/types';
import type { COLOR } from '#@/shared/utils/styles';

import { Description, IconWrapper, Message, TextWrapper, Title } from './Styles';

type MessagePopupProps = Pick<ToastObject, 'title' | 'message'> & {
  color: COLOR;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

const MessagePopup: React.FC<MessagePopupProps & Omit<ClickableProps, 'title'>> = ({
  color,
  title,
  message,
  leftIcon,
  rightIcon,
  onClick,
  ...props
}) => (
  <Message as={onClick ? Clickable : 'div'} color={color} onClick={onClick} {...props}>
    {leftIcon && <IconWrapper $position="first">{leftIcon}</IconWrapper>}
    <TextWrapper>
      <Title data-cy-message-popup-title>{title as ReactElement}</Title>
      {message && <Description data-cy-message-popup-message>{message}</Description>}
    </TextWrapper>
    {rightIcon && <IconWrapper $position="last">{rightIcon}</IconWrapper>}
  </Message>
);

export default MessagePopup;
